export function getCurrentStateFromChanges(changes) {
    const currentState = {};

    for(const propertyName of Object.keys(changes)) {
        if(changes[propertyName].currentValue) {
            currentState[propertyName] = changes[propertyName].currentValue;
        } else {
            currentState[propertyName] = changes[propertyName].previousValue;
        }
    }
    return currentState;
}